import { render, staticRenderFns } from "./FinderTabs.vue?vue&type=template&id=b9e24a74&"
import script from "./FinderTabs.vue?vue&type=script&lang=js&"
export * from "./FinderTabs.vue?vue&type=script&lang=js&"
import style0 from "./FinderTabs.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports